import { Observable } from 'rxjs';
import { Department, DataSourceResponse} from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class DepartmentService extends ApiService {
  endPoint = '/api/departments';
  create(model: Department) {
    return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: Department) {
    return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.commonBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<Department> {
    return this.http.get<Department>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<Department>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
  }
}
